'use strict';

var $ = window.jQuery;
var body = $(document.body);
var win = $(window);
var distance = 40;

function init() {

	var css = "scrolled";
	var eventHandler = function () {
		if ( win.scrollTop() < distance ) {
			body.removeClass( css );
		} else {
			body.addClass( css );
		}
	}
	eventHandler();
	win.on('scroll.addClass', eventHandler);

}

var ScrolledClass = {
	init: init
};

module.exports = ScrolledClass;